// Which balance a withdrawal / payout is paid from. Same vocabulary the bank
// withdraw form sends (`source`), now shared by crypto payouts and mobile money.
export type WithdrawalSource = 'account' | 'reward' | 'referral'

export const WITHDRAWAL_SOURCES: WithdrawalSource[] = ['account', 'reward', 'referral']

export const SOURCE_LABELS: Record<WithdrawalSource, string> = {
  account: 'Main Wallet',
  reward: 'Reward',
  referral: 'Referral',
}

export const normalizeSource = (v?: string | null): WithdrawalSource =>
  v === 'reward' || v === 'referral' ? v : 'account'

// GET /wallets returns balance (main), rewardBalance and referralBalance.
export const balanceFor = (wallet: any, source: WithdrawalSource): number | undefined => {
  if (!wallet) return undefined
  if (source === 'reward') return wallet.rewardBalance
  if (source === 'referral') return wallet.referralBalance
  return wallet.balance
}
